import React from 'react';

import SignInOrSignUpPage from './shared/SignInOrSignUpPage';

const SignUpPage = props => (
  <SignInOrSignUpPage next="/create-account/done/" type="signUp" {...props} />
);
export default SignUpPage;
